import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CircleAlertIcon, LucideAngularModule } from 'lucide-angular';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
	standalone: true,
	selector: 'app-help-banner',
	templateUrl: './help-banner.component.html',
	imports: [
		RouterLink,
		LucideAngularModule,
		TranslocoPipe,
	],
})
export class HelpBannerComponent implements OnInit {
	isBannerClosed = false;

	ngOnInit(): void {
		// Check localStorage to see if the banner was previously closed
		this.isBannerClosed = localStorage.getItem('bannerClosed') === 'true';
	}

	closeBanner(): void {
		this.isBannerClosed = true;
		localStorage.setItem('bannerClosed', 'true');
	}

	protected readonly CircleAlertIcon = CircleAlertIcon;
}
